import { Typography, Divider } from '@material-ui/core'

import { PriceRow } from '../../../../components/PriceRow'
import { getTranslate, lang } from '../../../../localization'
import { BillingSummary } from '../../../../types/cart'
import useStyles from './styles/index.styles'

type PriceDetailsCardProps = {
  billingData: BillingSummary
  step: number
  ratePlanNames: Record<string, string>
}

const FinalBillingSummary = ({
  billingData,
  step,
  ratePlanNames
}: PriceDetailsCardProps) => {
  const classes = useStyles()

  // const sitekeys = ['single:046631c3-249f-54d3-b51f-47eb7bb6036a']
  // const hideTax = sitekeys.includes(SITE_KEY)

  return (
    <div className={classes.card}>
      <div className={classes.topHeader}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Final Billing Summary')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.middle}>
        {billingData.roomsPrice
          .slice()
          .sort((a: { roomTypeName: string }, b: { roomTypeName: string }) =>
            a.roomTypeName.localeCompare(b.roomTypeName)
          )
          .map((roomPrice, i) => {
            const ratePlanName = ratePlanNames[roomPrice.ratePlanCode]
            const label = `${roomPrice.roomTypeName}${
              ratePlanName ? ` (${ratePlanName})` : ''
            }`
            return step === 1 ? (
              <PriceRow
                label={
                  lang === 'fa'
                    ? `${label} ${roomPrice.quantity}x`
                    : `${label}  x${roomPrice.quantity}`
                }
                value={roomPrice.price}
                currency={billingData.curruncy}
                key={i}
              />
            ) : (
              <PriceRow
                label={label}
                value={roomPrice.price}
                currency={billingData.curruncy}
                key={i}
              />
            )
          })}
        <PriceRow
          label={getTranslate(`Subtotal Before Discount`)}
          value={billingData.subTotalPrice.subTotalBeforeDiscount}
          currency={billingData.curruncy}
        />
      </div>
      <Divider />
      <div className={classes.middle}>
        <PriceRow
          label={getTranslate(`Discount`)}
          value={billingData.subTotalPrice.discount}
          currency={billingData.curruncy}
          isDiscount
        />
        {billingData.subTotalPrice.additionalDiscount &&
        billingData.subTotalPrice.additionalDiscount > 0 ? (
          <PriceRow
            label={getTranslate(`Additional Discount Amount`)}
            value={billingData.subTotalPrice.additionalDiscount}
            currency={billingData.curruncy}
            isDiscount
          />
        ) : (
          <></>
        )}
        <PriceRow
          label={getTranslate(`Subtotal After Discount`)}
          value={billingData.subTotalPrice.subTotalAfterDiscount}
          currency={billingData.curruncy}
        />
      </div>
      <Divider />
      <div className={classes.bottom}>
        {/* <PriceRow
          label={getTranslate(`Tax & Mandatory Fees`)}
          value={0}
          currency={billingData.curruncy}
        /> */}
        <PriceRow
          label={`${getTranslate('Total Amount Payable')}`}
          value={billingData.totalPayable}
          currency={billingData.curruncy}
          bold
        />
      </div>
    </div>
  )
}

export default FinalBillingSummary
